import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
} from 'react-native';
import { useFormPermissions } from '../../hooks/useFormPermissions';

interface UOMToggleProps {
  value?: string;
  onSelect?: (value: string) => void;
  disabled?: boolean;
  label?: string;
  useGlobalState?: boolean;
}

export const UOMToggle: React.FC<UOMToggleProps> = ({
  value = 'Imperial',
  onSelect,
  disabled = false,
}) => {
  const { canEditRequest } = useFormPermissions();
  const isDisabled = disabled || !canEditRequest;

  const handleSelect = (selectedValue: string) => {
    if (isDisabled || !onSelect) return;
    onSelect(selectedValue);
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity
        style={[
          styles.button,
          value === 'Imperial' && styles.activeButton,
          isDisabled && !(value === 'Imperial') && styles.disabledButton
        ]}
        onPress={() => handleSelect('Imperial')}
        disabled={isDisabled}
        accessibilityRole="button"
        accessibilityState={{ selected: value === 'Imperial', disabled: isDisabled }}
        testID="uom-imperial-button"
      >
        <Text style={[
          styles.buttonText,
          value === 'Imperial' && styles.activeButtonText,
          isDisabled && !(value === 'Imperial') && styles.disabledButtonText
        ]}>
          Imperial
        </Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={[
          styles.button,
          value === 'Metric' && styles.activeButton,
          isDisabled && !(value === 'Metric') && styles.disabledButton
        ]}
        onPress={() => handleSelect('Metric')}
        disabled={isDisabled}
        accessibilityRole="button"
        accessibilityState={{ selected: value === 'Metric', disabled: isDisabled }}
        testID="uom-metric-button"
      >
        <Text style={[
          styles.buttonText,
          value === 'Metric' && styles.activeButtonText,
          isDisabled && !(value === 'Metric') && styles.disabledButtonText
        ]}>
          Metric
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    margin: 0,
    padding: 0,
  },
  button: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
    marginLeft: 6,
    backgroundColor: 'transparent',
    // borderWidth: 1,
    // borderColor: '#ddd',
    ...Platform.select({
      web: {
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        ':hover': {
          borderColor: '#ff6b35',
        },
      },
    }),
  },
  activeButton: {
    backgroundColor: '#ff6b35',
    borderColor: '#ff6b35',
  },
  disabledButton: {
    backgroundColor: '#f8f9fa',
    ...Platform.select({
      web: {
        cursor: 'not-allowed',
      },
    }),
  },
  buttonText: {
    fontSize: 11,
    fontWeight: '500',
    color: '#666',
  },
  activeButtonText: {
    color: '#fff',
  },
  disabledButtonText: {
    color: '#495057',
    fontWeight: '500',
  },
});